@if (isOpen) {
<div
  #dropdownRef
  class="absolute z-40 right-0 mt-2 rounded-xl border border-gray-200 bg-white shadow-theme-lg dark:border-gray-800 dark:bg-gray-dark"
  [ngClass]="className"
>
  <ng-content></ng-content>
</div>
}